import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import {
  decimalInvertedReportFormatter,
  percentageReportFormatter,
} from "../../fomatters/DecimalFormatter";
import GameStatisticReport from "../GameStatisticReport";
import InputSelect from "../InputSelect";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function GameStatistics() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChanged = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  const [groupBy, setGroupBy] = useState(0);
  const onGroupByChange = useCallback(
    (event) => setGroupBy(Number(event.target.value)),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [period, setPeriod] = useState("");
  const onPeriodChanged = useCallback(
    (event) => setPeriod(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [league, setLeague] = useState("");
  const onLeagueChanged = useCallback((l) => setLeague(l), []);
  const { values: leagues } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/League/League_GetAllLeagues`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="League"
          name="name"
          data={leagues}
          placeholder="DataFormatter"
          setSelectValue={onLeagueChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Group By">
            <FormControl component="fieldset">
              <RadioGroup label value={groupBy} onChange={onGroupByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="None"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Office"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Player"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Sport"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Bet Type"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Period"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="Play"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Player Type">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Masters"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Period"
          type="text"
          value={period}
          size="small"
          onChange={onPeriodChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <GameStatisticReport
        title="Game Statistics Report"
        getUrl={() => "/Reports/Report_Game_Statistic_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Office: office,
          Player: player,
          League: league,
          OrderBy: orderBy,
          GroupBy: groupBy,
          Distributor: distributor,
          Period: period,
        })}
        getProcess={(item) => ({
          ...item,
          hold:
            Math.round((item.winLost / item.amount + Number.EPSILON) * 10000) /
            100,
        })}
        getTotals={(data) => {
          const totalAmount =
            Math.round(data.reduce((acc, item) => acc + item.amount, 0) * 100) /
            100;
          const totaWinLost =
            Math.round(
              data.reduce((acc, item) => acc + item.winLost, 0) * 100
            ) / 100;

          const totalHold =
            Math.round((totaWinLost / totalAmount + Number.EPSILON) * 10000) /
            100;

          return {
            group3: "SubTotals",
            amount: totalAmount,
            winLost: totaWinLost,
            hold: totalHold,
          };
        }}
      >
        {/* REAL COLUMNS */}
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="group3">
          Period
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="group4">
          Play
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risked
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winLost"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win/Lost
        </TableHeaderColumn>
        {/* PENDING */}
        <TableHeaderColumn
          dataSort
          dataField="hold"
          dataFormat={percentageReportFormatter}
        >
          HoldPct
        </TableHeaderColumn>
      </GameStatisticReport>
    </div>
  );
}

export default GameStatistics;
